import { IconTrashOutline } from '@iwoca/icons';
import { Card } from '@iwoca/orion';
import { ButtonLink } from 'components/ButtonLink/ButtonLink';
import { RefinancingDebtFields } from '../RefinancingDebtFields/RefinancingDebtFields';
import styles from './DebtCard.module.css';

type TProps = {
  index: number;
  showHeader: boolean;
  canRemove: boolean;
  onRemove: () => void;
  disabled?: boolean;
};

export const DebtCard = ({
  index,
  showHeader,
  canRemove,
  onRemove,
  disabled,
}: TProps) => {
  return (
    <Card className={styles.card}>
      {showHeader && (
        <div className={styles.header}>
          <h3 className={styles.title}>Debt {index + 1}</h3>
          {canRemove && (
            <ButtonLink
              type="button"
              className={styles.remove}
              aria-label={`Remove debt ${index + 1}`}
              data-testid={`remove-debt-${index + 1}`}
              onClick={onRemove}
              disabled={disabled}
            >
              <IconTrashOutline fontSize="1.4rem" />
            </ButtonLink>
          )}
        </div>
      )}
      <RefinancingDebtFields index={index} disabled={disabled} />
    </Card>
  );
};
